export class PaymentGateways {
  public static EPX = 'EPX';
  public static Forte = 'FORTE';
  public static PlacePay = 'RENTSHARE';
  public static Stripe = 'STRIPE';
  public static Convergence = 'CONVERGE';
  public static Burton = 'BURTON';
}
